import React from 'react';
import { Responsive, useResponsive } from '~/lib/useResponsive';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { CAROUSEL_TINDER } from '../itemIds';
import {
  CarouseTinderlProvider,
  CarouselTinderVariants
} from './CarouselTinderStore';
import { CarouselTinderComponent } from './components/CarouselTinderComponent';
import { QuizProvider } from '../quiz/QuizStore';

interface Props {
  variant?: Responsive<CarouselTinderVariants>;
}

export type CarouselTinderDefinition = ItemDefinition<
  typeof CAROUSEL_TINDER,
  Props
>;

export class CarouselTinder extends Item<typeof CAROUSEL_TINDER, Props> {
  protected render({ variant, children, id }: RenderProps<Props>) {
    const v = useResponsive(variant) || 'standard';

    return (
      <QuizProvider quizId={id || 'default'}>
        <CarouseTinderlProvider>
          <CarouselTinderComponent variant={v} id={id}>
            {children}
          </CarouselTinderComponent>
        </CarouseTinderlProvider>
      </QuizProvider>
    );
  }
}

registry[CAROUSEL_TINDER] = CarouselTinder;
